<template>
  <winery-component/>
</template>

<script>
import WineryComponent from '@/spa/components/board/winery/BoardWinery';

export default {
  name: 'WineryPage',
  components: {
    WineryComponent,
  },
};
</script>



// WEBPACK FOOTER //
// src/spa/pages/contents/WineryPage.vue